import React from "react";
import Navbar from "../../components/layout/header/Navbar";
import CursorGlow from "../../components/common/CursorGlow";
import HeroModern from "../../components/hero/HeroModern";
import LogoInterstitial from "../../components/hero/LogoInterstitial";
import ScrollStory from "../../components/story/ScrollStory";
import BentoFeatures from "../../components/features/BentoFeatures";
import AudienceSplit from "../../components/features/AudienceSplit";
import AboutModern from "../../components/about/AboutModern";
import FaqModern from "../../components/Faqs/FaqModern";
import CtaModern from "../../components/cta/CtaModern";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/layout/footer/Footer";

export default function HomeFour() {
  return (
    // `overflowX: clip` rather than `hidden` — `hidden` would make this a
    // scroll container and break the pinned story section.
    <div style={{ backgroundColor: "#ffffff", minHeight: "100vh", overflowX: "clip" }}>
      <CursorGlow />
      <Navbar />

      <main>
        {/* Minimal first viewport — copy recedes, product takes over on scroll */}
        <HeroModern />

        {/* Wordmark breather between the hero and the deep dive */}
        <LogoInterstitial />

        {/* Pinned product story: customers → EMI → payments → transactions → insights */}
        <ScrollStory />

        {/* Feature bento, each panel animating what it describes */}
        <BentoFeatures />

        {/* Orders / Customers — the app's own two home-screen tiles */}
        <AudienceSplit />

        <AboutModern />
        <FaqModern />
        <CtaModern />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}
